import { initializeFirestore, Timestamp } from "firebase/firestore";
import { brand } from "@/constants/brandVariables/brandVariables";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, type User } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FB_CNFG_API_KEY,
  authDomain: import.meta.env.VITE_FB_CNFG_DOMAIN,
  databaseURL: import.meta.env.VITE_FB_CNFG_DATABASE_URL,
  projectId: import.meta.env.VITE_FB_CNFG_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FB_CNFG_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FB_CNFG_SENDER_ID,
  appId: import.meta.env.VITE_FB_CNFG_APP_ID,
};

const app = initializeApp(firebaseConfig);

// Initialize Firebase

export const firestore = initializeFirestore(
  app,
  { experimentalAutoDetectLongPolling: true },
  "gt-database",
);
export const storage = getStorage(app);
export const database_1 = getDatabase(app);

export const cacheDatabase = getDatabase(
  app,
  import.meta.env.VITE_FB_CNFG_CACHE_DATABASE_URL,
);
// auth
export const auth = getAuth(app);
auth.tenantId = brand?.tenantId || "";

export type FirebaseUser = User;
export const timestamp = Timestamp;

//functions
export const functions = getFunctions(app, "europe-west1");
export const Functions = (functionName: string) => {
  return httpsCallable(functions, functionName);
};
